import React, {Suspense} from 'react';
import {BrowserRouter} from 'react-router-dom'; 
import {ThemeProvider} from '@material-ui/styles'
import theme from './theme/'; 
import './assets/scss/index.scss';
import LoadingSpinner from './common/UI/LoadingSpinner';
import Routes from './Routes';
import validate from 'validate.js';
import validators from './common/validators';
import {useAuth} from './common/hooks/auth-hook'; 
import {AuthContext} from './common/context/auth-context'; 
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE);

validate.validators = { //add checkbox validator to validate.js 
  ...validate.validators,
  ...validators
};


const App = () => {
  const {token, userId,email,tenant, error, login, logout, clearError, updateSettings, authProvider, stripeStatus} = useAuth(); 
  return (
    <Elements stripe={stripePromise}>
    <AuthContext.Provider value={{isLoggedIn: !!token, userId: userId, email: email, tenant: tenant, error: error, token: token, login: login, logout: logout, clearError: clearError, updateSettings: updateSettings, authProvider: authProvider, stripeStatus: stripeStatus}}>
    <ThemeProvider theme={theme}>
        <BrowserRouter> 
          <Suspense fallback ={<div align='center'><LoadingSpinner open={true}/></div>}><Routes /></Suspense>
        </BrowserRouter>
      </ThemeProvider>
      </AuthContext.Provider> 
      </Elements>
  );
}

export default App;
